import dayjs from 'dayjs';
import { TFunction } from 'i18next';
import { toCapitalCase } from 'utils/common/String';

export function formatTo24HourMin(dateString: any) {
  if (typeof dateString !== 'string' && !(dateString instanceof Date)) {
    return '';
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return '';
  }
  const h = date.getHours().toString().padStart(2, '0');
  const m = date.getMinutes().toString().padStart(2, '0');
  return `${h}:${m}`;
}
export function formatToYMD(dateString: any): string {
  if (typeof dateString !== 'string' && !(dateString instanceof Date)) {
    return '';
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return '';
  }
  const Y = date.getFullYear();
  const M = (date.getMonth() + 1).toString().padStart(2, '0');
  const D = date.getDate().toString().padStart(2, '0');

  return `${Y}-${M}-${D}`;
}

export function formatDate(dateString: any) {
  if (typeof dateString !== 'string' && !(dateString instanceof Date)) {
    return '';
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return '';
  }
  // Format the date as "DD/MM/YYYY"
  const formattedDate = date.toLocaleDateString('th-TH', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  return formattedDate;
}

export function formatDaysText(days: string[], t: TFunction): string {
  if (!days || days.length === 0) return '';

  if (days.length === 7) {
    return t('Everyday');
  }

  return days.map((day) => t(toCapitalCase(day))).join(', ');
}

export const formatDateTime = (value: any) =>
  value ? dayjs(value.replace(' ', 'T')).format('DD/MM/YYYY HH:mm:ss') : '';

export const displayDateTime = (value: any): string => {
  if (!value) return '';

  const strValue = String(value).trim();

  if (strValue === '' || strValue === '0000-00-00 00:00:00') {
    return '';
  }

  const parsed = dayjs(strValue.replace(' ', 'T'));

  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm:ss') : '';
};

export function hoursToHHMM(hours: number): string {
  if (!Number.isFinite(hours)) return '00:00';

  const totalMinutes = Math.round(hours * 60);

  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
